import { CheckoutExtension } from '@getjust/checkout-extensions';
import { useMemo } from 'react';

import { useShop } from '../queries';

/**
 * Hook for managing extension events using ExtensionManager
 */
export const useExtensions = (): CheckoutExtension[] => {
  const { data: shop } = useShop();
  return useMemo(() => shop?.settings?.checkoutExtensions ?? [], [shop]);
};
